import React, { useCallback } from "react";
import classNames from "classnames";
import { useScope } from "@state/scopeContext.lib";
import {
    ENTERPRISE_TRIAL_CALL_URL,
    FRESHBOOKS_TRIAL_CALL_URL,
} from "@common/billing";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { useWidgetOptions } from "@design-system/BookCall/useWidgetOptions";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useStartEnterpriseTrialMutation } from "@api/flatRateBilling.api";
import { useUpdateUserMutation } from "@api/user.api";
import animations from "../layout/OnboardingLayout.module.scss";
import { Footer } from "../components/Footer";
import commonStyles from "./common.module.scss";

interface Props {
    onContinue(): void;
    back(): void;
}

export const EnterpriseCall: React.FC<Props> = ({ onContinue, back }) => {
    const updateUser = useUpdateUserMutation();
    const { workspaceId: activeWorkspaceId } = useScope();
    const workspace = useActiveWorkspace();
    const startEnterpriseTrialMutation = useStartEnterpriseTrialMutation(
        activeWorkspaceId as string,
    );

    const handleEnterpriseCallBooked = useCallback(async () => {
        await startEnterpriseTrialMutation.mutateAsync();
        await updateUser.mutateAsync({ bookedEnterpriseCall: true });
        onContinue();
    }, [onContinue, updateUser, startEnterpriseTrialMutation]);

    const { prefill, pageSettings } = useWidgetOptions({});

    useCalendlyEventListener({
        onEventScheduled: handleEnterpriseCallBooked,
    });

    return (
        <div
            className={classNames(animations.fadeIn1, commonStyles.content1100)}
        >
            <header className={animations.fadeIn2}>
                <h1 className={commonStyles.title}>Talk to a Kick Expert</h1>

                <p className={commonStyles.subtitle}>
                    Book your Introduction Call to get access to Kick
                </p>
            </header>

            <InlineWidget
                url={
                    workspace?.isFreshbooksCustomer
                        ? FRESHBOOKS_TRIAL_CALL_URL
                        : ENTERPRISE_TRIAL_CALL_URL
                }
                pageSettings={pageSettings}
                prefill={prefill}
            />

            <Footer onBack={back} />
        </div>
    );
};
